// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1bCmK","content":"GlobalSearch_content__3T-QY"};